<template>
  <div class="rexer_event-contact">
    <a
      :href="renderHref"
      title=""
      target="_blank"
    >
      <span
        class="rexer_event-contact__icon"
        v-html="renderIcon"
      />
      <span
        class="rexer_event-contact__name"
      >
        {{ text }}
      </span>
    </a>
  </div>
</template>

<script>
import { svg } from '../helpers/config'
export default {
  name: 'EventContact',
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      globeIcon: svg.GLOBE,
      emailIcon: svg.EMAIL
    }
  },
  computed: {
    renderHref () {
      let res = ''
      switch (this.type) {
        case 'www':
          res = this.text
          break
        case 'email':
          res = `mailto: ${this.text}`
          break
      }
      return res
    },
    renderIcon () {
      let res = ''
      switch (this.type) {
        case 'www':
          res = this.globeIcon
          break
        case 'email':
          res = this.emailIcon
          break
      }
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
  $text-color: #fff;
  $card-bg-color: #000;
  $purple: #b004ff;
  $blue: #0248ff;
  $green: #00ff00;
  .rexer_event-contact {
    a {
      color: $text-color;
      display: flex;
      align-items: center;
      line-height: 1.3;
      padding: 0.5rem 0;
      font-size: 1rem;
      &:hover, &:focus, &:active {
        color: $green;
        outline: 0 none;
      }
    }
    span {
      display: inline-block;
    }
    &__icon {
      width: 1.5rem;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0.5rem;
      svg {
        width: 1em;
        height: 1em;
      }
    }
  }
</style>
